import { TableCellWithBadge } from "../../../../data-model/tableCells";

const INTERNAL_BADGE = {
  text: "Internal",
  textColor: "#665D00",
  bgColor: "#FFFBEB",
};

const EXTERNAL_BADGE = {
  text: "External",
  textColor: "#0056D6",
  bgColor: "#E6F0FF",
};

/**
 * Maps pharmacy_type to Internal/External badge styles for the PA Requests table.
 *
 * @input pharmacyType - Raw pharmacy_type from the order row
 * @return TableCellWithBadge: Badge cell value for the Pharmacy Type column
 */
export const getPharmacyTypeBadgeStyles = (
  pharmacyType: string | null | undefined,
): TableCellWithBadge => {
  const normalized = (pharmacyType ?? "").trim().toLowerCase();

  if (normalized === "external") {
    return {
      text: EXTERNAL_BADGE.text,
      color: EXTERNAL_BADGE.textColor,
      bgColor: EXTERNAL_BADGE.bgColor,
      hoverText: EXTERNAL_BADGE.text,
    };
  }

  return {
    text: INTERNAL_BADGE.text,
    color: INTERNAL_BADGE.textColor,
    bgColor: INTERNAL_BADGE.bgColor,
    hoverText: INTERNAL_BADGE.text,
  };
};
